import { SwRedux } from "app/services/SwRedux";

export const getCountryFromFC = () => {
    const swRedux = SwRedux.getInstance();
    const { digitalSuiteSelectedCountry } = swRedux.getState().usersDigitalSuiteFiltersSelection;
    return digitalSuiteSelectedCountry;
};
